import create from "zustand";

const pauseHoverStore = create((set) => ({
  pauseHover: true,
  setPauseHover: (pauseHover) => set({ pauseHover }),
}));

export default pauseHoverStore;